<app-tabs>
  <app-tab Title="Designer">
    <div class="mapeditor-outer" [formGroup]="Form">
      <div class="mapeditor-toolbox">
        <div class="toolbar-item">
          <button class="button is-primary" (click)="SetScale(ViewScale*.95)">
            <i class="fa fa-minus"></i>
          </button>
        </div>
        <div class="toolbar-item">
          <button class="button is-primary" (click)="SetScale(ViewScale*1.05)">
            <i class="fa fa-plus"></i>
          </button>
        </div>
        <div class="toolbar-item">
          <button class="button is-default" (click)="Snapping = !Snapping">
            <i class="fa fa-magnet" *ngStyle="{'color': Snapping ? '000000' : '333333'}"></i>
            Snapping: {{Snapping?'on' : 'off'}}
          </button>
        </div>
        <div class="toolbar-item">
          <div class="dropdown" #tooldropdown (click)="tooldropdown.classList.toggle('is-active')">
            <div class="dropdown-trigger">
              <button class="button is-default" aria-haspopup="true" aria-controls="dropdown-menu">
                <span>Load</span>
                <span class="icon is-small">
                  <i class="fa fa-angle-down" aria-hidden="true"></i>
                </span>
              </button>
            </div>
            <div class="dropdown-menu" id="dropdown-menu" role="menu">
              <div class="dropdown-content">
                <a class="dropdown-item" (click)="ImportLevel()">
                  Copy existing Level
                </a>
              </div>
            </div>
          </div>
        </div>
        @for (t of Tools; track t) {
          <div class="toolbar-item">
            @if (t.Tool != null) {
              <button class="button" (click)="SelectTool(t)">{{t.Name}}</button>
            }
            @if (t.Tools != null) {
              <div class="dropdown" #tooldropdown
                (click)="tooldropdown.classList.toggle('is-active')">
                <div class="dropdown-trigger">
                  <button class="button is-default" aria-haspopup="true" aria-controls="dropdown-menu">
                    <span>{{t.Name}}</span>
                    <span class="icon is-small">
                      <i class="fa fa-angle-down" aria-hidden="true"></i>
                    </span>
                  </button>
                </div>
                <div class="dropdown-menu" id="dropdown-menu" role="menu">
                  <div class="dropdown-content">
                    @for (s of t.Tools; track s) {
                      <a class="dropdown-item" (click)="SelectTool(s)">
                        {{s.Name}}
                      </a>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        }

      </div>
      <div class="mapeditor-inner" tabindex="0" #DesignSurface (mousemove)="DesignSurfaceMouseMove($event)"
        (mouseup)="DesignSurfaceMouseUp($event)" (mouseleave)="DesignSurfaceMouseUp($event)"
        (mousedown)="DesignSurfaceMouseDown($event)" (click)="DesignSurfaceClick($event)"
        (keydown)="DesignSurfaceKeyPress($event)" (wheel)="DesignerMouseWheel($event)">
        <div class="design-surface" [ngStyle]="{'cursor' : DragType == 'pan' ? 'pointer' : 'auto' }">
          @for (i of MapItemsByType.get('ParkingLevel'); track i) {
            <svg class="mapitem {{i.ClassName}}">
              <path [attr.d]="i.path" stroke="black" stroke-width="1" (click)="ItemClicked($event,i)"
                (mousedown)="ItemMouseDown($event, i)">
              </path>
              @if (i.FormControl.get('Name') != null) {
                <text [attr.x]="ViewScale * i.Left"
                  [attr.y]="ViewScale*(i.Top)+12">
                  {{i.FormControl.get('Name')?.value}}
                </text>
              }
            </svg>
          }
          @for (i of MapItemsByType.get('ParkingRow'); track i) {
            <svg class="mapitem {{i.ClassName}}">
              <defs>
                <pattern id="rowHatch" width="8" height="8" patternUnits="userSpaceOnUse"
                  patternTransform="rotate(45)">
                  <rect width="4" height="8" transform="translate(0,0)" fill="#aaa"></rect>
                </pattern>
              </defs>
              <path [attr.d]="i.path" stroke="black" stroke-width="1"
                style="fill:url(#rowHatch); opacity: 0.1" (click)="ItemClicked($event,i)"
                (mousedown)="ItemMouseDown($event, i)">
              </path>
              @if (i.FormControl.get('Name') != null) {
                <text [attr.x]="ViewScale * i.Left"
                  [attr.y]="ViewScale*(i.Top)+12">
                  {{i.FormControl.get('Name')?.value}}
                </text>
              }
            </svg>
          }
          @for (i of MapItemsByType.get('Gate'); track i) {
            <svg class="mapitem {{i.ClassName}}">
              <defs>
                <pattern id="diagonalHatch" width="8" height="8" patternUnits="userSpaceOnUse"
                  patternTransform="rotate(45)">
                  <rect width="4" height="8" transform="translate(0,0)" fill="green"></rect>
                </pattern>
              </defs>
              <path [attr.d]="i.path" stroke="black" stroke-width="1"
                style="fill:url(#diagonalHatch); opacity: 0.1;" (click)="ItemClicked($event,i)"
                (mousedown)="ItemMouseDown($event, i)" (dblclick)="EditGate(i);">
              </path>
              @if (i.FormControl.get('Name') != null) {
                <text [attr.x]="ViewScale * i.Left"
                  [attr.y]="ViewScale*(i.Top)+12">
                  {{i.FormControl.get('Name')?.value}}
                </text>
              }
            </svg>
          }
          @for (i of MapItemsByType.get('Lane'); track i) {
            <svg class="mapitem {{i.ClassName}}">
              <defs>
                <pattern id="laneHatch" width="8" height="8" patternUnits="userSpaceOnUse"
                  patternTransform="rotate(45)">
                  <rect width="4" height="8" transform="translate(0,0)" fill="purple"></rect>
                </pattern>
              </defs>
              <path [attr.d]="i.path" stroke="black" stroke-width="1"
                style="fill:url(#laneHatch); opacity: 0.2;" (click)="ItemClicked($event,i)"
                (mousedown)="ItemMouseDown($event, i)" (dblclick)="EditLane(i);">
              </path>
              @if (i.FormControl.get('Name') != null) {
                <text [attr.x]="ViewScale * i.Left"
                  [attr.y]="ViewScale*(i.Top)+12">
                  {{i.FormControl.get('Name')?.value}}
                </text>
              }
            </svg>
          }
          @for (i of MapItemsByType.get('ParkingSpace'); track i) {
            <svg class="mapitem {{i.ClassName}}">
              <path [attr.d]="i.path" [attr.style]="'fill:' + i.GetFillColor() + '; fill-opacity:0.4'"
                [attr.stroke]="i.GetStrokeColor()" stroke-width="1" (click)="ItemClicked($event,i)"
                (mousedown)="ItemMouseDown($event, i)">
              </path>
              <g [innerHTML]="i.GetImage(i.Top*ViewScale, i.Height*ViewScale, i.Left*ViewScale)"
                [ngStyle]="{ 'transform': 'rotate(' + i.DisplayAngle + 'deg)', 'transform-origin': i.Center[0]*ViewScale + 'px ' + i.Center[1]*ViewScale + 'px' }">
                @if (i.FormControl.get('Name') != null) {
                  <text [attr.x]="ViewScale * i.Left"
                    [attr.y]="ViewScale*(i.Top)">
                    {{i.FormControl.get('Name')?.value}}
                  </text>
                }
              </g>
              @if (i.FormControl.get('Name') != null) {
                <text [attr.x]="ViewScale * i.Left + 3"
                  [attr.font-size]="0.001*ViewScale" [attr.y]="ViewScale*(i.Top)+(0.0012*ViewScale)">
                  {{i.FormControl.get('Name')?.value}}
                </text>
              }
            </svg>
          }
          <svg class="mapitem">
            <defs>
              <pattern id="laneHatch" width="8" height="8" patternUnits="userSpaceOnUse"
                patternTransform="rotate(45)">
                <rect width="4" height="8" transform="translate(0,0)" fill="green"></rect>
              </pattern>
            </defs>
            @for (i of MapItemsByType.get('Shape'); track i) {
              <g>
                <path [attr.d]="i.path" [attr.stroke]="'#' + i.FormControl.get('OutlineColor')?.value"
                  [attr.stroke-width]="i.FormControl.get('OutlineThickness')?.value"
                  [attr.fill]="'#' + i.FormControl.get('FillColor')?.value"
                  [ngStyle]="{ 'transform': 'rotate(' + i.DisplayAngle + 'deg)', 'opacity': i.FormControl.get('Opacity')?.value }"
                  (click)="ItemClicked($event,i)" (mousedown)="ItemMouseDown($event, i)">
                </path>
                <path [attr.d]="i.entryPath" stroke="blue"
                  stroke-width="5">
                </path>
                <path [attr.d]="i.exitPath" stroke="blue"
                  stroke-width="5">
                </path>
                @if (i.FormControl.get('Name') != null && i.FormControl.get('Type')?.value == 'BusinessDirectory') {
                  <text
                    [attr.x]="ViewScale * i.Left + 3" [attr.font-size]="0.001*ViewScale"
                    [attr.y]="ViewScale*(i.Top)+(0.0012*ViewScale)" style="font-weight: bold;" wrap="hard">
                    {{GetBusinessDirectoryName(i.FormControl.get('BusinessDirectoryId')?.value)}}
                  </text>
                }
              </g>
            }
          </svg>
          @for (i of MapItemsByType.get('LocalController'); track i) {
            <svg class="mapitem {{i.ClassName}}">
              <image href="/assets/levelmap/terminal.svg" [attr.x]="i.Left*ViewScale"
                [attr.y]="i.Top*ViewScale" [attr.height]="i.Height*ViewScale"
                [attr.width]="i.Width*ViewScale" (click)="ItemClicked($event,i)"
                (dblclick)="EditLocalController(i);" (mousedown)="ItemMouseDown($event, i)"
                [ngStyle]="{ 'transform': 'rotate(' + i.DisplayAngle + 'deg)', 'transform-origin': i.Center[0]*ViewScale + 'px ' + i.Center[1]*ViewScale + 'px' }" />
                @if (i.FormControl.get('Name') != null) {
                  <text [attr.x]="ViewScale * i.Left"
                    [attr.y]="ViewScale*(i.Top)">
                    {{i.FormControl.get('Name')?.value}}
                  </text>
                }
              </svg>
            }
            @for (i of MapItemsByType.get('Camera'); track i) {
              <svg class="mapitem {{i.ClassName}}">
                <image href="/assets/levelmap/camera.svg" [attr.x]="i.Left*ViewScale" [attr.y]="i.Top*ViewScale"
                  [attr.height]="i.Height*ViewScale" [attr.width]="i.Width*ViewScale"
                  (click)="ItemClicked($event,i)" (dblclick)="EditCamera(i);"
                  (mousedown)="ItemMouseDown($event, i)"
                  [ngStyle]="{ 'transform': 'rotate(' + i.DisplayAngle + 'deg)', 'transform-origin': i.Center[0]*ViewScale + 'px ' + i.Center[1]*ViewScale + 'px' }" />
                  <text [attr.x]="ViewScale * i.Left" [attr.y]="ViewScale*(i.Top)">
                    {{i.FormControl.get('LocalIpAddress')?.value}}
                  </text>
                </svg>
              }
              @for (i of MapItemsByType.get('Barrier'); track i) {
                <svg class="mapitem {{i.ClassName}}">
                  <g
                    [ngStyle]="{ 'transform': 'rotate(' + i.DisplayAngle + 'deg)', 'transform-origin': i.Center[0]*ViewScale + 'px ' + i.Center[1]*ViewScale + 'px' }">
                    <image href="/assets/levelmap/barrier.svg" [attr.x]="i.Left*ViewScale"
                      [attr.y]="i.Top*ViewScale" [attr.height]="i.Height*ViewScale"
                      [attr.width]="i.Width*ViewScale" (click)="ItemClicked($event,i)"
                      (dblclick)="EditBarrier(i);" (mousedown)="ItemMouseDown($event, i)" />
                      @if (i.FormControl.get('Name') != null) {
                        <text [attr.x]="ViewScale * i.Left"
                          [attr.y]="ViewScale*(i.Top)">
                          {{i.FormControl.get('Name')?.value}}
                        </text>
                      }
                    </g>
                  </svg>
                }
                @for (i of MapItemsByType.get('TrafficLight'); track i) {
                  <svg class="mapitem {{i.ClassName}}">
                    <g
                      [ngStyle]="{ 'transform': 'rotate(' + i.DisplayAngle + 'deg)', 'transform-origin': i.Center[0]*ViewScale + 'px ' + i.Center[1]*ViewScale + 'px' }">
                      <image href="/assets/levelmap/trafficlight.svg" [attr.x]="i.Left*ViewScale"
                        [attr.y]="i.Top*ViewScale" [attr.height]="i.Height*ViewScale"
                        [attr.width]="i.Width*ViewScale" (click)="ItemClicked($event,i)"
                        (dblclick)="EditTrafficLight(i);" (mousedown)="ItemMouseDown($event, i)" />
                        @if (i.FormControl.get('Name') != null) {
                          <text [attr.x]="ViewScale * i.Left"
                            [attr.y]="ViewScale*(i.Top)">
                            {{i.FormControl.get('Name')?.value}}
                          </text>
                        }
                      </g>
                    </svg>
                  }
                  @for (i of MapItemsByType.get('GatewayConfiguration'); track i) {
                    <svg class="mapitem">
                      <g
                        [ngStyle]="{ 'transform': 'rotate(' + i.DisplayAngle + 'deg)', 'transform-origin': i.Center[0]*ViewScale + 'px ' + i.Center[1]*ViewScale + 'px' }">
                        <image href="/assets/levelmap/gateway.svg" [attr.x]="i.Left*ViewScale"
                          [attr.y]="i.Top*ViewScale" [attr.height]="i.Height*ViewScale"
                          [attr.width]="i.Width*ViewScale" (click)="ItemClicked($event,i)"
                          (dblclick)="EditGatewayConfiguration(i);" (mousedown)="ItemMouseDown($event, i)" />
                          @if (i.FormControl.get('Name') != null) {
                            <text [attr.x]="ViewScale * i.Left"
                              [attr.y]="ViewScale*(i.Top)">
                              {{i.FormControl.get('Name')?.value}}
                            </text>
                          }
                        </g>
                      </svg>
                    }
                    @for (i of MapItemsByType.get('CarCounterConfiguration'); track i) {
                      <svg class="mapitem">
                        <g
                          [ngStyle]="{ 'transform': 'rotate(' + i.DisplayAngle + 'deg)', 'transform-origin': i.Center[0]*ViewScale + 'px ' + i.Center[1]*ViewScale + 'px' }">
                          <image href="/assets/levelmap/carcounter.svg" [attr.x]="i.Left*ViewScale"
                            [attr.y]="i.Top*ViewScale" [attr.height]="i.Height*ViewScale"
                            [attr.width]="i.Width*ViewScale" (click)="ItemClicked($event,i)"
                            (dblclick)="EditCarCounterConfiguration(i);" (mousedown)="ItemMouseDown($event, i)" />
                            @if (i.FormControl.get('Name') != null) {
                              <text [attr.x]="ViewScale * i.Left"
                                [attr.y]="ViewScale*(i.Top)">
                                {{i.FormControl.get('Name')?.value}}
                              </text>
                            }
                          </g>
                        </svg>
                      }
                      @for (i of MapItemsByType.get('SignConfiguration'); track i) {
                        <svg class="mapitem">
                          <g
                            [ngStyle]="{ 'transform': 'rotate(' + i.DisplayAngle + 'deg)', 'transform-origin': i.Center[0]*ViewScale + 'px ' + i.Center[1]*ViewScale + 'px' }">
                            <image href="/assets/levelmap/sign.svg" [attr.x]="i.Left*ViewScale"
                              [attr.y]="i.Top*ViewScale" [attr.height]="i.Height*ViewScale"
                              [attr.width]="i.Width*ViewScale" (click)="ItemClicked($event,i)"
                              (dblclick)="EditSignConfiguration(i);" (mousedown)="ItemMouseDown($event, i)" />
                              @if (i.FormControl.get('Name') != null) {
                                <text [attr.x]="ViewScale * i.Left"
                                  [attr.y]="ViewScale*(i.Top)">
                                  {{i.FormControl.get('Name')?.value}}
                                </text>
                              }
                            </g>
                          </svg>
                        }
                        @for (i of MapItemsByType.get('GuidanceLightConfiguration'); track i) {
                          <div>
                            <svg class="mapitem">
                              <g [ngStyle]="{ 'transform': 'rotate(' + i.DisplayAngle + 'deg)', 'transform-origin': i.Center[0]*ViewScale + 'px ' + i.Center[1]*ViewScale + 'px' }">
                                <image href="/assets/levelmap/guidancelight.svg" [attr.x]="i.Left*ViewScale"
                                  [attr.y]="i.Top*ViewScale" [attr.height]="i.Height*ViewScale"
                                  [attr.width]="i.Width*ViewScale" (click)="ItemClicked($event,i)"
                                  (mousedown)="ItemMouseDown($event, i)" />
                                  @if (i.FormControl.get('Name') != null) {
                                    <text [attr.x]="ViewScale * i.Left"
                                      [attr.y]="ViewScale*(i.Top)">
                                      {{i.FormControl.get('Name')?.value}}
                                    </text>
                                  }
                                </g>
                              </svg>
                            </div>
                          }
                          <svg class="mapitem">
                            @for (i of SelectedItems; track i) {
                              <g>
                                @if (i.Resizable) {
                                  <g>
                                    @for (point of i.BisectPoints; track point; let ix = $index) {
                                      <circle
                                        [attr.cx]="point[0]*ViewScale" [attr.cy]="point[1]*ViewScale" r="6" stroke="black"
                                        fill="#aaa" (mousedown)="BisectionPointMouseDown($event, point, i, ix)">
                                      </circle>
                                    }
                                    @for (point of i.PolygonPoints; track point; let ix = $index) {
                                      <circle
                                        [attr.cx]="point[0]*ViewScale" [attr.cy]="point[1]*ViewScale" r="8" stroke="black"
                                        fill="red" (mousedown)="PointMouseDown($event, i, point, ix)">
                                      </circle>
                                    }
                                  </g>
                                }
                              </g>
                            }
                            @if (SelectionBounds != null) {
                              <g>
                                <circle
                                  [attr.cx]="(SelectionBounds.Left + ((SelectionBounds.Right-SelectionBounds.Left)/2))*ViewScale"
                                  [attr.cy]="(SelectionBounds.Bottom+0.001)*ViewScale" r="5" stroke="black" fill="green"
                                  (mousedown)="RotateMouseDown($event)">
                                </circle>
                              </g>
                            }
                          </svg>
                          @if (Marquee != null) {
                            <svg class="mapitem marquee">
                              <path stroke-dasharray="5,5" [attr.d]="Marquee" fill="none" stroke="blue" stroke-width="1"
                              style=" pointer-events: none;"></path>
                            </svg>
                          }
                        </div>
                      </div>

                      <div class="mapeditor-properties">
                        <div class="is-size-4">Properties</div>
                        @if (SelectedItems.length > 0) {
                          <div class="is-small">
                            <table class="table is-striped properties-table">
                              <thead>
                                <tr>
                                  <th>Name</th>
                                  <th>Value</th>
                                </tr>
                              </thead>
                              <tbody>
                                @if (SelectedItems.length > 0 && SelectedItems[0].ClassName === 'GuidanceLightConfiguration') {
                                  <tr>
                                    <td>Id</td>
                                    <td><input class="input" readonly [formControl]="SelectedItems[0].FormControl.get('Id')"/></td>
                                  </tr>
                                }
                                @if (SelectedItems[0].FormControl.get('EditorLocked') != null) {
                                  <tr>
                                    <td>
                                      Locked
                                    </td>
                                    <td>
                                      <input type="checkbox" style="vertical-align: bottom;"
                                        [formControl]="SelectedItems[0].FormControl.get('EditorLocked')"
                                        (change)="UpdateSelectedItemsProperty('EditorLocked')">
                                      </td>
                                    </tr>
                                  }
                                  @if (SelectedItems[0].FormControl.get('Name') != null) {
                                    <tr>
                                      <td>
                                        Name
                                      </td>
                                      <td>
                                        <input class="input" type="text"
                                          [formControl]="SelectedItems[0].FormControl.get('Name')">
                                        </td>
                                      </tr>
                                    }
                                    <!-- We add this in, to show on street kiosks in the public facing app. These are the only ones with IsPublicFacing = true-->
                                    @if (SelectedItems[0].FormControl.get('IsPublicFacing') != null && SelectedItems[0].FormControl.get('IsPublicFacing').value) {
                                      <tr>
                                        <td>
                                          MediaId
                                        </td>
                                        <td>
                                          @if (SelectedItems[0].FormControl.get('MediaId').value != null) {
                                            <app-media-thumbnail [MediaId]="SelectedItems[0].FormControl.get('MediaId').value" Title="Media Item"  ModalImageWidth="300px" ModalImageHeight="300px" ThumbnailHeight="60px" ThumbnailWidth="60px"></app-media-thumbnail>
                                            }&nbsp;&nbsp;
                                            <app-mediaupload [MediaId]="SelectedItems[0].FormControl.get('MediaId').value" Type=".svg" (MediaIdChange)="MediaIdChanged($event)"></app-mediaupload>
                                            @if (MediaIdsMisMatch(SelectedItems[0].FormControl.get('MediaId').value)) {
                                              <button class="button is-primary is-small" (click)="LineUpMedia(SelectedItems[0].FormControl.get('MediaId').value)"> Line up all MediaIds</button>
                                            }
                                          </td>
                                        </tr>
                                      }
                                      @if (SelectedItems[0].FormControl.get('LocalControllerId') != null) {
                                        <tr>
                                          <td>
                                            Controller
                                          </td>
                                          <td>
                                            <select class="input"
                                              [formControl]="SelectedItems[0].FormControl.get('LocalControllerId')"
                                              name="LocalControllerId">
                                              @for (c of ModelEditor.FormArray(ModelEditor.Form,'Controllers').controls; track c) {
                                                <option
                                                [ngValue]="c.get('Id')?.value">{{c.get('Name')?.value}}</option>
                                              }
                                            </select>
                                          </td>
                                        </tr>
                                      }
                                      @if (SelectedItems[0].FormControl.get('Type')?.value == 'BusinessDirectory') {
                                        <tr>
                                          <td>
                                            Business
                                          </td>
                                          <td>
                                            <app-businessselector
                                              [formControl]="SelectedItems[0].FormControl.get('BusinessDirectoryId')"
                                              [Business]="GetBusiness(SelectedItems[0].FormControl.get('BusinessDirectoryId')?.value)"
                                              (BusinessIdChange)="BusinessIdChange($event)" class="newclass">
                                            </app-businessselector>
                                          </td>
                                        </tr>
                                      }
                                      @if (SelectedItems[0].FormControl.get('OutlineColor') != null) {
                                        <tr>
                                          <td>
                                            Line
                                          </td>
                                          <td>
                                            <app-colorpicker [formControl]="SelectedItems[0].FormControl.get('OutlineColor')">
                                            </app-colorpicker>
                                          </td>
                                        </tr>
                                      }
                                      @if (SelectedItems[0].FormControl.get('FillColor') != null) {
                                        <tr>
                                          <td>
                                            Line
                                          </td>
                                          <td>
                                            <app-colorpicker [formControl]="SelectedItems[0].FormControl.get('FillColor')">
                                            </app-colorpicker>
                                          </td>
                                        </tr>
                                      }
                                      <tr>
                                        <td>
                                          Width (m)
                                        </td>
                                        <td>
                                          <input class="input" type="number" step="0.1"
                                            [value]="(SelectedItems[0].Width*1000).toFixed(1)"
                                            (change)="SetItemWidth($event)">
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            Height (m)
                                          </td>
                                          <td>
                                            <input class="input" type="number" step="0.1"
                                              [value]="(SelectedItems[0].Height*1000).toFixed(1)"
                                              (change)="SetItemHeight($event)">
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              Left
                                            </td>
                                            <td>
                                              <input class="input" type="number" step="0.1"
                                                [value]="(SelectedItems[0].Left*1000).toFixed(1)">
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                Top
                                              </td>
                                              <td>
                                                <input class="input" type="number" step="0.1"
                                                  [value]="(SelectedItems[0].Top*1000).toFixed(1)">
                                                </td>
                                              </tr>
                                              @if (SelectedItems[0].FormControl.get('ParkingSpaceTypeId') != null) {
                                                <tr>
                                                  <td>
                                                    Type
                                                  </td>
                                                  <td>
                                                    <select class="input"
                                                      [formControl]="SelectedItems[0].FormControl.get('ParkingSpaceTypeId')"
                                                      name="ClassName">
                                                      <option [ngValue]="null"></option>
                                                      @for (a of ParkingSpaceTypes; track a) {
                                                        <option [ngValue]="a.Id"><img
                                                        [src]="a.HtmlImage" />{{a.Name}}</option>
                                                      }
                                                    </select>
                                                  </td>
                                                </tr>
                                              }
                                              @if (SelectedItems[0].FormControl.get('ParkingSpaceTypeId') != null) {
                                                <tr>
                                                  <td>
                                                    Sensor
                                                  </td>
                                                  <td>
                                                    <app-sensor-selector [formControl]="SelectedItems[0].FormControl.get('ChipId')"
                                                      [Sensor]="InitialSensor">
                                                    </app-sensor-selector>
                                                  </td>
                                                </tr>
                                              }
                                              @if (SelectedItems[0].ClassName == 'ParkingSpace') {
                                                <tr>
                                                  <td>
                                                    Guidance Light Assignment
                                                  </td>
                                                  <td>
                                                    <div class="control select">
                                                      <select class="input" [formControl]="SelectedItems[0].FormControl.get('GuidanceLightConfigurationId')" >
                                                        @for (i of MapItemsByType.get('GuidanceLightConfiguration'); track i) {
                                                          <option [value]="i.FormControl.get('Id')?.value">{{i.FormControl.get('Name')?.value}}</option>
                                                        }
                                                      </select>
                                                    </div>
                                                  </td>
                                                </tr>
                                              }
                                              @if (SelectedItems[0].ClassName == 'ParkingSpace') {
                                                <tr>
                                                  <td>
                                                    Port Number
                                                  </td>
                                                  <td>
                                                    <input class="input" type="number" min="1" max="6" [formControl]="SelectedItems[0].FormControl.get('GuidanceLightPortNumber')">
                                                  </td>
                                                </tr>
                                              }
                                              @if (SelectedItems[0].ClassName == 'GatewayConfiguration') {
                                                <tr>
                                                  <td>
                                                    Gateway
                                                  </td>
                                                  <td>
                                                    <app-gateway-selector [formControl]="SelectedItems[0].FormControl.get('ChipId')"
                                                      [Gateway]="InitialGateway">
                                                    </app-gateway-selector>
                                                  </td>
                                                </tr>
                                              }
                                              @if (SelectedItems[0].ClassName == 'GatewayConfiguration') {
                                                <tr>
                                                  <td>
                                                    APN
                                                  </td>
                                                  <td>
                                                    <input class="input" type="text" [formControl]="SelectedItems[0].FormControl.get('Apn')" />
                                                  </td>
                                                </tr>
                                              }
                                              @if (SelectedItems[0].ClassName == 'SignConfiguration') {
                                                <tr>
                                                  <td>
                                                    Sign
                                                  </td>
                                                  <td>
                                                    <app-sign-selector [formControl]="SelectedItems[0].FormControl.get('ChipId')"
                                                      [Sign]="InitialSign">
                                                    </app-sign-selector>
                                                  </td>
                                                </tr>
                                              }
                                              @if (SelectedItems[0].ClassName == 'Barrier') {
                                                <tr>
                                                  <td>
                                                    Commands
                                                  </td>
                                                  <td>
                                                    <div class="p-1">
                                                      <button type="button" class="button is-small is-primary"
                                                      (click)="OpenBarrier(SelectedItems[0].FormControl.get('Id').value)">Open</button>
                                                    </div>
                                                    <div class="p-1">
                                                      <button type="button" class="button is-small is-primary"
                                                        (click)="KeepBarrierOpen(SelectedItems[0].FormControl.get('Id').value)">Keep
                                                      Open</button>
                                                    </div>
                                                    <div class="p-1">
                                                      <button type="button" class="button is-small is-primary"
                                                      (click)="CloseBarrier(SelectedItems[0].FormControl.get('Id').value)">Close</button>
                                                    </div>
                                                  </td>
                                                </tr>
                                              }
                                              @if (SelectedItems[0].FormControl.get('Type')?.value == 'Ramp' ||
                                                SelectedItems[0].FormControl.get('Type')?.value == 'BusinessDirectory' ||
                                                SelectedItems[0].FormControl.get('Type')?.value == 'Stairwell') {
                                                <tr>
                                                  <td>
                                                    Entry Segment
                                                  </td>
                                                  <td>
                                                    <input type="number" class="input" [formControl]="SelectedItems[0].FormControl.get('EntrySegment')" (change)="CalculateEntryPath($event)">
                                                  </td>
                                                </tr>
                                              }
                                              @if (SelectedItems[0].FormControl.get('Type')?.value == 'Ramp' ||
                                                SelectedItems[0].FormControl.get('Type')?.value == 'BusinessDirectory') {
                                                <tr>
                                                  <td>
                                                    Exit Segment
                                                  </td>
                                                  <td>
                                                    <input type="number" class="input" [formControl]="SelectedItems[0].FormControl.get('ExitSegment')" (change)="CalculateExitPath($event)">
                                                  </td>
                                                </tr>
                                              }
                                              @if (SelectedItems[0].FormControl.get('Type')?.value == 'Ramp') {
                                                <tr>
                                                  <td>
                                                    Is Rising
                                                  </td>
                                                  <td>
                                                    <input type="checkbox" [formControl]="SelectedItems[0].FormControl.get('IsRising')">
                                                  </td>
                                                </tr>
                                              }
                                              @if (SelectedItems.length > 0 && SelectedItems[0].ClassName === 'GuidanceLightConfiguration') {
                                                <tr>
                                                  <td>
                                                    Port / SpaceId
                                                  </td>
                                                  <td>
                                                    @for (assignment of SelectedItems[0]?.FormControl.get('PortAssignments')?.controls; track assignment) {
                                                      <div class="columns" style="margin:10px;">
                                                        <div class="column is-6" style="padding:0px;">
                                                          <input class="input" type="text" [formControl]="assignment.get('PortNumber')">
                                                        </div>
                                                        <div class="column is-6" style="padding:0px;">
                                                          <div class="control select">
                                                            <select class="input" [formControl]="assignment.get('ParkingSpaceId')" >
                                                              @for (i of MapItemsByType.get('ParkingSpace'); track i) {
                                                                <option [value]="i.FormControl.get('Id')?.value">{{i.FormControl.get('Name')?.value}}</option>
                                                              }
                                                            </select>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    }
                                                    <button class="button is-primary" (click)="AddAssignment()">Add Assignment</button>
                                                  </td>
                                                </tr>
                                              }
                                            </tbody>
                                          </table>
                                        </div>
                                      }
                                    </div>

                                  </div>
                                </app-tab>
                                <app-tab Title="Location">
                                  <app-field Label="Rotation">
                                    <div class="control">
                                      <input type="number" class="input" [(ngModel)]="GoogleMapRotation" min="-180" max="180"
                                        (ngModelChange)="UpdateGoogleMapPath(null,null)" />
                                      </div>
                                    </app-field>
                                    <button (click)="CenterLevelOnMap()">Center</button>



                                    {{GoogleMapSpaces.length}} space polys

                                    <google-map width="100%" height="600" [center]="GoogleMapCenter" [zoom]="18">
                                      @for (s of GoogleMapSpaces; track s) {
                                        <map-polygon [paths]="s"
                                        [options]="{ draggable: false, strokeColor: '#ffffff', strokeWeight: 1 }"></map-polygon>
                                      }
                                      <map-polygon [paths]="GoogleMapLevelPath" [options]="{ draggable: true, editable: false }"
                                      (polygonDragend)="GoogleMapLevelDragged($event)"></map-polygon>
                                    </google-map>

                                  </app-tab>
                                </app-tabs>